module.exports = __webpack_public_path__ + "static/img/banner1.6b4c4cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/banner1.jpg
// module id = o9m7
// module chunks = 1